<nav class="side-nav" [ngClass]="{ 'side-nav--collapsed': !expanded }">
  @if (displayMode === 'DEFAULT') {
    <button
      class="side-nav__expand-btn"
      type="button"
      ftrButton
      [displayType]="buttonDisplayType.Icon"
      [autoWidth]="true"
      [title]="expanded ? 'Collapse' : 'Expand'"
      (click)="toggleExpanded.emit()"
      ftrTooltip
      [message]="expanded ? 'Collapse' : 'Expand'"
      [showDash]="false"
      [position]="tooltipPosition.RIGHT"
    >
      <ftr-icon
        [icon]="expanded ? 'KeyboardArrowLeft' : 'KeyboardArrowRight'"
        [align]="'TextTop'"
        [color]="'Grey'"
      ></ftr-icon>
    </button>
  }
  <div class="side-nav__header">
    <div class="side-nav__header-logo" [ngClass]="{ 'side-nav__header-logo--collapsed': !expanded }">
      <ftr-logo
        [size]="expanded ? logoSize.Small : logoSize.ExtraSmall"
        [theme]="expanded ? logoTheme.ThemedWhite : logoTheme.ThemedNoText"
      ></ftr-logo>
    </div>
  </div>
  <div class="side-nav__body">
    @for (navGroup of navGroups; track navGroups) {
      @if (!navGroup.position) {
        <ng-container *ngTemplateOutlet="navGroupTemplate; context: { $implicit: navGroup }"></ng-container>
      }
    }
  </div>
  <div class="side-nav__footer">
    @for (navGroup of navGroups; track navGroups) {
      @if (navGroup?.position === 'footer') {
        <ng-container *ngTemplateOutlet="navGroupTemplate; context: { $implicit: navGroup }"></ng-container>
      }
    }
  </div>
</nav>

<ng-template #navGroupTemplate let-navGroup>
  <div class="side-nav__group">
    @if (navGroup.title; as navGroupTitle) {
      <div class="side-nav__group-title" [ngClass]="{ 'side-nav__group-title--collapsed': !expanded }">
        {{ navGroupTitle }}
      </div>
    }
    @for (navItem of navGroup.items; track navItem) {
      <button
        class="side-nav__item"
        type="button"
        ftrButton
        [color]="buttonColor.Grey"
        [fullWidth]="true"
        [title]="navItem.title"
        ftrTooltip
        [message]="navItem.title"
        [showDash]="false"
        [position]="tooltipPosition.RIGHT"
        [forceDisplayState]="expanded ? tooltipDisplay.Hide : undefined"
        (click)="navItem.onSelect ? navItem.onSelect() : {}"
        [routerLink]="navItem.path"
      >
        <ftr-icon [icon]="navItem.icon" [size]="'Small'"></ftr-icon>
        <div class="side-nav__item-title" [ngClass]="{ 'side-nav__item-title--collapsed': !expanded }">
          {{ navItem.title }}
        </div>
      </button>
    }
  </div>
</ng-template>
